import { Injectable } from '@angular/core';
import { Company } from './company';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { resolve } from 'path';
import { CryptoService } from 'src/app/shared/crypto/crypto.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  companyList: Company[];
 
  private url = "AdmEmpresas";

  constructor(
    private generalHttp: GeneralHttpService,
    private encryptService: CryptoService,
  ) {}

  refreshList() {
    return this.generalHttp.getHttp(this.url).then(r => this.companyList = r as Company[]);
  }

  postCompany(formData: Company) {
    return this.generalHttp.postHttp(formData, this.url);
  }

  getCompany() {
    return this.generalHttp.getHttp(this.url);
  }

  getCompanyForNit(nit: any) {
    return this.generalHttp.getHttpById(nit, this.url + "/GetAdmEmpresaForNit");
  }

  getCompanyByUser(id: number) { 
    let companiesString = sessionStorage.getItem('lCompany');
    if(companiesString == null || companiesString == '[]'){
      let form = {
        id: this.encryptService.encryptToSend(id.toString())
      }
      return this.generalHttp.postHttp(form, this.url + "/ByUserId").then(r => {      
        this.companyList = r as Company[];
        let tempList = JSON.stringify(this.companyList);
        sessionStorage.setItem('lCompany',tempList);
      });
    }else{
      return new Promise((resolve)=>{
        this.companyList = JSON.parse(companiesString);
        resolve("OK");
      });
    }
  }

  getAdmEmpresaSearch(name:string){
    return this.generalHttp.getHttpById(name,`${this.url}/GetAdmEmpresaSearch`);
  }

  getEmpresasByUser(idUser:number){
    return this.generalHttp.getHttpById(idUser,`${this.url}/GetEmpresasByUser`);
  }

} 
